<script setup lang="ts">
import { twMerge, type ClassNameValue } from "tailwind-merge"
const { error, class: _class } = defineProps<{
  error?: unknown
  class?: ClassNameValue
}>()
const { getErrorText } = useLocalisedError()

const errorText = computed(() => {
  if (!error) {
    return
  }
  return getErrorText(error)
})
</script>
<template>
  <Alert
    v-if="error"
    variant="error"
    animate-in
    :class="twMerge('mb-4', _class)"
  >
    <AlertIcon>
      <SvgoPikaAlertCircle />
    </AlertIcon>
    <AlertText>
      <template v-if="errorText">
        <ul v-if="Array.isArray(errorText)" class="ml-4 list-disc space-y-1.5">
          <li v-for="_error in errorText" :key="_error">
            {{ _error }}
          </li>
        </ul>
        <template v-else>
          {{ errorText }}
        </template>
      </template>
    </AlertText>
  </Alert>
</template>
